import styled from "styled-components";
import { defaultBreakpoints } from "styled-media-query";

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.default.color.backgrounds.light};
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
  margin-top: 1rem;
  border-radius: 8px;

  .ghost-btn {
    background-color: transparent;
    color: ${({ theme }) => theme.default.color.primary};
    border: ${({ theme }) =>
    `1px solid ${theme.default.color.primary}`};
  }
`;


export const CroppedImage = styled.img`
  height: 100px;
  width: 50%;
  object-fit: contain;
  margin-bottom: 1rem;

  @media (max-width: ${defaultBreakpoints.medium}) {
    width: 100%;
  }
`;
